/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { Button, Flex, Grid, TextField } from "@aws-amplify/ui-react";
import { Button as BSButton, Container, Row, Col } from 'react-bootstrap';
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Friends } from "../models";
import { fetchByPath, validateField } from "./utils";
import { DataStore, Auth } from "aws-amplify";
export default function FriendsCreate(props) {
  const {
    clearOnSuccess = true,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    Name: "",
    FriendOf: "",
  };
  const [Name, setName] = React.useState(initialValues.Name);
  const [FriendOf, setFriendOf] = React.useState(initialValues.FriendOf);
  React.useEffect(()=>{
    getOwner().then(u => setFriendOf(u));
  },[])
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    setName(initialValues.Name);
    //setFriendOf(initialValues.FriendOf);
    setErrors({});
  };
  const validations = {
    Name: [],
    FriendOf: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value = getDisplayValue
      ? getDisplayValue(currentValue)
      : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };

  async function getOwner() {
    //override who it belongs to
    let user = await Auth.currentAuthenticatedUser();
    console.log("friendOf: ", user.username);
    return user.username;
  }

  const [existingFriends, setExistingFriends] = React.useState([]);

  const getOrderKey = (owner) => `friends-order-${owner}`;

  const applySavedOrder = (friends, owner) => {
    let savedOrder = [];
    try {
      savedOrder = JSON.parse(localStorage.getItem(getOrderKey(owner)) || "[]");
    } catch (e) {}
    const order = new Map(savedOrder.map((id, index) => [id, index]));
    return [...friends].sort((a, b) => {
      const aOrder = order.has(a.id) ? order.get(a.id) : Number.MAX_SAFE_INTEGER;
      const bOrder = order.has(b.id) ? order.get(b.id) : Number.MAX_SAFE_INTEGER;
      return aOrder - bOrder || a.Name.localeCompare(b.Name);
    });
  };

  const saveOrder = (friends, owner) => {
    try {
      localStorage.setItem(getOrderKey(owner), JSON.stringify(friends.map(friend => friend.id)));
    } catch (e) {}
  };

  async function getFriends() {
    const owner = await getOwner();
    const friends = await DataStore.query(Friends, f => f.FriendOf.eq(owner));
    setExistingFriends(applySavedOrder(friends, owner));
  }

  React.useEffect(() => {
    getFriends();
  }, []);

  async function removeFriend(friend) {
    await DataStore.delete(friend);
    await getFriends();
  }

  async function renameFriend(friend) {
    const newName = window.prompt("Enter a new name", friend.Name || "");
    if (!newName || !newName.trim() || newName.trim() === friend.Name) return;
    const updatedFriend = Friends.copyOf(friend, updated => {
      updated.Name = newName.trim();
    });
    await DataStore.save(updatedFriend);
    await getFriends();
  }

  async function moveFriend(index, direction) {
    const targetIndex = index + direction;
    if (targetIndex < 0 || targetIndex >= existingFriends.length) return;
    const reorderedFriends = [...existingFriends];
    [reorderedFriends[index], reorderedFriends[targetIndex]] = [reorderedFriends[targetIndex], reorderedFriends[index]];
    setExistingFriends(reorderedFriends);
    const owner = await getOwner();
    saveOrder(reorderedFriends, owner);
  }

  return (
    <Container>
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          Name,
          FriendOf,
        };
        console.log(modelFields);
        console.log(FriendOf);
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          console.log("Validation error!");
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value.trim() === "") {
              modelFields[key] = undefined;
            }
          });
          console.log(modelFields);
          await DataStore.save(new Friends(modelFields));
          if (onSuccess) {
            onSuccess(modelFields);
          }
          if (clearOnSuccess) {
            resetStateValues();
          }
          getFriends()
        } catch (err) {
          if (onError) {
            onError(modelFields, err.message);
          }
        }
      }}  
      {...getOverrideProps(overrides, "FriendsCreate")}
      {...rest}
    >
      <TextField
        columnStart="1"
        columnEnd="-1"
        label="Name"
        isRequired={false}
        isReadOnly={false}
        value={Name}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              Name: value,
              FriendOf,
            };
            const result = onChange(modelFields);
            value = result?.Name ?? value;
          }
          if (errors.Name?.hasError) {
            runValidationTasks("Name", value);
          }
          setName(value);
        }}
        onBlur={() => runValidationTasks("Name", Name)}
        errorMessage={errors.Name?.errorMessage}
        hasError={errors.Name?.hasError}
        {...getOverrideProps(overrides, "Name")}
      ></TextField>
      <Flex
        columnStart="1"
        columnEnd="-1"
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button 
          children="Clear"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          {...getOverrideProps(overrides, "ClearButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Add Friend"
            type="submit"
            variation="primary"
            isDisabled={Object.values(errors).some((e) => e?.hasError)}
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
    <Container>
      <Col>
        <Row><em>Current Friends</em></Row>
        {existingFriends.map((friend, index) => (
          <Row key={friend.id} className="align-items-center mb-2">
            <Col>{friend.Name}</Col>
            <Col xs="auto">
              <BSButton variant="outline-primary" size="sm" onClick={() => renameFriend(friend)}>
                Rename
              </BSButton>
            </Col>
            <Col xs="auto">
              <BSButton variant="outline-secondary" size="sm" onClick={() => moveFriend(index, -1)} disabled={index === 0}>
                Move up
              </BSButton>
            </Col>
            <Col xs="auto">
              <BSButton variant="outline-secondary" size="sm" onClick={() => moveFriend(index, 1)} disabled={index === existingFriends.length - 1}>
                Move down
              </BSButton>
            </Col>
            <Col xs="auto">
              <BSButton variant="primary" size="sm" onClick={() => removeFriend(friend)}>
                Remove
              </BSButton>
            </Col>
          </Row>
        ))}
      </Col>
  </Container>
  </Container>
  );
}
